import { GlobalActions, GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { select, takeEvery } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import dayjs from 'dayjs';
import { DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';
import { IAppState } from '../toolbarState';

export function* watchInitialStoreManagementDataRequested() {
  yield takeEvery(
    GlobalActions.INITIAL_STORE_MANAGEMENT_DATA_REQUESTED,
    safeSaga(provideInitialStoreManagementData, App.SHOP_TOOLBAR),
  );
}

function* provideInitialStoreManagementData() {
  const state: IAppState = yield select();
  const { geburtsdatum, isAssekuranztarif, adresse, juristisch, kundennummer } =
    state.versicherungsnehmer;
  const { zahlungsart, zahlungsweise } = state.zahlungsoptionen;
  const selectedKooperation = state.aktionsnachlassCode?.code;
  const kooperationen = state.transientState.kooperationen;

  GlobalEventDispatcher.getInstance().dispatch(
    new GlobalActions().provideInitialStoreManagementData({
      versicherungsnehmer: {
        geburtsdatum,
        isAssekuranztarif,
        adresse,
        juristisch,
        kundennummer,
      },
      vertragsoptionen: {
        zahlungsart,
        zahlungsweise,
        selectedKooperation,
        angebotsdatum:
          state.transientState.customAngebotsdatum ?? dayjs().format(DATEFORMAT_SHORT_ISO),
      },
      kooperationen,
    }),
  );
}
